import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";

const DASHBOARD_PASSWORD_HASH = "ebb13c9c3eb76a43440606dcef83d780675f8de6c79fc8b8ea55655feae84630";

const PasswordProtection = ({ children }) => {
   const [isAuthenticated, setIsAuthenticated] = useState(false);
   const [password, setPassword] = useState("");
   const [error, setError] = useState("");
   const [isLoading, setIsLoading] = useState(false);

   const hashPassword = (password) => {
      return CryptoJS.SHA256(password + "driverify-salt").toString();
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setError("");

      // Small delay to prevent brute force attacks
      setTimeout(() => {
         const hashedInput = hashPassword(password);

         if (hashedInput === DASHBOARD_PASSWORD_HASH) {
            setIsAuthenticated(true);
            sessionStorage.setItem("dashboard_auth", "true");
         } else {
            setError("Invalid password. Please try again.");
            setPassword("");
         }
         setIsLoading(false);
      }, 500);
   };

   // Check if already authenticated
   useEffect(() => {
      if (sessionStorage.getItem("dashboard_auth") === "true") {
         setIsAuthenticated(true);
      }
   }, []);

   if (isAuthenticated) {
      return children;
   }

   return (
      <div className="dashboard-wrapper">
         <div className="password-protection-container">
            <div className="password-form-wrapper">
               <div className="password-header">
                  <div className="lock-icon">
                     <i className="bi bi-shield-lock"></i>
                  </div>
                  <h1>Dashboard Access</h1>
                  <p>Please enter the password to continue</p>
               </div>

               <form onSubmit={handleSubmit} className="password-form">
                  {error && (
                     <div className="alert alert-danger mb-3">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        {error}
                     </div>
                  )}

                  <div className="form-group">
                     <label htmlFor="password">Password</label>
                     <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="password-input"
                        placeholder="Enter dashboard password"
                        disabled={isLoading}
                        autoFocus
                     />
                  </div>

                  <button
                     type="submit"
                     className="btn-primary"
                     disabled={isLoading || !password.trim()}
                  >
                     {isLoading ? (
                        <>
                           <div className="loading me-2"></div>
                           Verifying...
                        </>
                     ) : (
                        <>
                           <i className="bi bi-unlock-fill me-2"></i>
                           Access Dashboard
                        </>
                     )}
                  </button>
               </form>
            </div>
         </div>
      </div>
   );
};

export default PasswordProtection;
